import React from "react";
import {Career } from "../components";
import "./../App.css";
const Career_page = () => {
  return (
    <div>
      <Career />
    </div>
  );
};

export default Career_page;
